import { render } from "./NewsCategory.vue?vue&type=template&id=29e4699c&scoped=true"
import script from "./NewsCategory.vue?vue&type=script&lang=js"
export * from "./NewsCategory.vue?vue&type=script&lang=js"

import "./NewsCategory.vue?vue&type=style&index=0&id=29e4699c&lang=scss&scoped=true"
import "./NewsCategory.vue?vue&type=style&index=1&id=29e4699c&lang=scss&scoped=true"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29e4699c"]])

export default __exports__